/**
 * Task #1527 — Listener bus per errori 422 STORAGE_QUOTA_EXCEEDED /
 * DB_QUOTA_EXCEEDED_EMBEDDINGS. L'apiClient di ciascun frontend dispatcha
 * `STORAGE_QUOTA_ERROR_EVENT` con payload tipizzato; questo hook fornisce
 * il listener riusabile dal toast provider e da eventuali consumer custom.
 */
import { useEffect, useRef } from 'react';
import type { StorageQuotaErrorPayload } from '@easyflow/shared';

export type { StorageQuotaErrorPayload, StorageQuotaErrorCode } from '@easyflow/shared';

export const STORAGE_QUOTA_ERROR_EVENT = 'edgvoip:storage-quota-error';

export type StorageQuotaErrorHandler = (payload: StorageQuotaErrorPayload) => void;

export function useStorageQuotaErrors(handler: StorageQuotaErrorHandler): void {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    function onError(e: Event): void {
      const ce = e as CustomEvent<StorageQuotaErrorPayload>;
      if (!ce.detail) return;
      ref.current(ce.detail);
    }
    window.addEventListener(STORAGE_QUOTA_ERROR_EVENT, onError);
    return () => window.removeEventListener(STORAGE_QUOTA_ERROR_EVENT, onError);
  }, []);
}

export function dispatchStorageQuotaError(payload: StorageQuotaErrorPayload): void {
  try {
    window.dispatchEvent(new CustomEvent<StorageQuotaErrorPayload>(STORAGE_QUOTA_ERROR_EVENT, { detail: payload }));
  } catch { /* SSR-safe no-op */ }
}
